import { styled } from 'styled-components'

import type { OrchestratedAuctionListingDetails } from '@b-stock/fe-core/bstock-next/queries'
import {
  CurrencyStringDollars,
  FormattedMessage,
  PrecisionNumberFormat,
} from '@b-stock/fe-core/bstock-react'
import { Typography } from '@b-stock/fe-core/design-system'

const BuyNowAmountDisplay = styled.span`
  ${Typography.Title3}
`

interface BuyNowAmountProps {
  listing: OrchestratedAuctionListingDetails
  buyNowPrice: number
  currency?: string
}

const BuyNowAmount = ({
  listing,
  buyNowPrice,
  currency = 'USD',
}: BuyNowAmountProps) => {
  const isContract = listing.listingType === 'CONTRACT'
  const contract = listing.contract
  const bidBasis = contract?.bidBasis
  const bidUnit = contract?.bidUnit
  const bidPrecision = listing.auction.bidPrecision

  const isRelative = bidBasis === 'RELATIVE'

  if (isContract && contract && bidBasis && bidUnit) {
    const amount = (
      <PrecisionNumberFormat
        value={buyNowPrice}
        precision={bidPrecision}
        precisionStored={1}
        format={isRelative ? 'percent' : 'currency'}
        currency={currency}
      />
    )

    return (
      <BuyNowAmountDisplay>
        <FormattedMessage
          id={`BStockNext.Contracts.Enums.perUnitAmount.sentenceCase.${bidUnit}`}
          values={{ amount }}
        />
      </BuyNowAmountDisplay>
    )
  }
  return (
    <BuyNowAmountDisplay data-testid="fallback-currency">
      <CurrencyStringDollars value={buyNowPrice} currency={currency} />
    </BuyNowAmountDisplay>
  )
}

export default BuyNowAmount
